// extracted by mini-css-extract-plugin
module.exports = {"header":"Error_header__XhwiJ","message":"Error_message__DCrGV"};